// extracted by mini-css-extract-plugin
export default {"cls1":"RelatedPapers-cls1_Baz","cls2":"RelatedPapers-cls2__Vg RelatedPapers-cls1_Baz"};